<div style="display: flex; width: 100%;">
    <div style="margin-right: 1rem; border: solid 1px gainsboro; cursor: pointer;" *ngFor="let presImage of listImage let i = index" width="5rem">
        <img (click)="PreviewImage(listImage,i)" style="height: 80px;" class="prescription-image" src="{{presImage}}">
    </div>
</div>
<div style="position: fixed; top: 0px;left: 0;background: rgba(0, 0, 0, 0.95); z-index: 999; width: 100%; height: 100vh;"
    *ngIf="currentImage">
    
    <ngx-image-viewer  [src]="currentImage" [(index)]="imageIndex"></ngx-image-viewer>
</div>